// extracted by mini-css-extract-plugin
export default {"list":"Services_list__cbU3M","card":"Services_card__QYwvW","imgWrapper":"Services_imgWrapper__z129X","img":"Services_img__uP0Tz","title":"Services_title__426tH"};